import React from 'react';
import ReactDOM from 'react-dom';
import { HeroApp } from './HeroApp';

ReactDOM.render(
    <HeroApp />,
  document.getElementById('root')
);

